// extracted by mini-css-extract-plugin
export default {"mainTitle":"Login_mainTitle__QjtqE","mainPicture":"Login_mainPicture__wnrmW","borderBackground":"Login_borderBackground__JER-y"};